import AllotmentDetails from "@/features/allotments/components/allotment-details";
import { appDetailTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

type AllotmentDetailSearch = {
  date?: string;
};

export const Route = createFileRoute("/_app/allotments/$id")({
  validateSearch: (search: Record<string, unknown>): AllotmentDetailSearch => {
    const date = typeof search.date === "string" && search.date.length > 0 ? search.date : undefined;
    return date !== undefined ? { date } : {};
  },
  head: () => appDetailTitleHead("allotments"),
  component: AllotmentDetailPage
});

function AllotmentDetailPage() {
  return (
    <div className="w-full">
      <AllotmentDetails />
    </div>
  );
}
